import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';

import { useAppSelector } from 'src/hooks/useStore';
import { RootState } from 'src/store';
import {
  FormCompleteNotification,
  FormRequestNotification,
} from 'src/store/notifications/types';
import { isUnreadNotification } from 'src/utils/NotificationsUtils';

const selectFormRequestNotifications = createSelector(
  (state: RootState) => state.notifications.formRequestNotifications,
  (state: RootState) => state.activeCompany.activeCompanyId,
  (formRequestNotifications, activeCompanyId) =>
    formRequestNotifications.filter(
      (notif) => notif.companyId === activeCompanyId,
    ),
);

export const useFormsNotificationCount = (): number => {
  const isClient = useAppSelector((state: RootState) => state.user.isClient);

  const completedFormNotifs =
    useAppSelector(
      (state: RootState) => state.notifications.formCompletedNotifications,
    ) || [];
  const requestFormNotifs = useAppSelector(selectFormRequestNotifications);

  // Get the notifications from the store according to the user role
  const notifications: FormCompleteNotification[] | FormRequestNotification[] =
    !isClient ? completedFormNotifs : requestFormNotifs;

  return useMemo(() => {
    const unreadNotifications = notifications.filter(
      (notif: FormCompleteNotification | FormRequestNotification) =>
        isUnreadNotification(notif.ownerId),
    );
    return unreadNotifications.length;
  }, [notifications]);
};
